import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "pt-4 mt-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = {
  key: 2,
  class: "row mt-3"
}
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = {
  key: 3,
  class: "row mt-3"
}
const _hoisted_19 = {
  key: 0,
  class: "col-6"
}
const _hoisted_20 = { class: "row mt-4" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "pt-5" }
const _hoisted_24 = { class: "xl" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "text-center"
}
const _hoisted_27 = { class: "mt-5" }
const _hoisted_28 = { class: "coverage-table" }
const _hoisted_29 = {
  key: 0,
  class: "coverage-table--head"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
    /*#__PURE__*/_createElementVNode("strong", { class: "font-15 color-primary" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Carrier name")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, [
    /*#__PURE__*/_createElementVNode("strong", { class: "font-15 color-primary text-end" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Network")
    ])
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-2" }, null, -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 1,
  class: "coverage-table--body"
}
const _hoisted_34 = { class: "coverage-list pt-3" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-5" }
const _hoisted_37 = { class: "col-7" }
const _hoisted_38 = { class: "font-15 text-end" }
const _hoisted_39 = {
  key: 0,
  class: "my-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_SelectDataTypes = _resolveComponent("SelectDataTypes")!
  const _component_SelectBundle = _resolveComponent("SelectBundle")!
  const _component_SelectPurchaseType = _resolveComponent("SelectPurchaseType")!
  const _component_SelectValidityType = _resolveComponent("SelectValidityType")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_Partner = _resolveComponent("Partner")!
  const _component_TabsDialog = _resolveComponent("TabsDialog")!

  return (_openBlock(), _createBlock(_component_TabsDialog, {
    modelValue: _ctx.selectedTab,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedTab) = $event)),
    title: _ctx.title,
    opened: _ctx.opened,
    "modal-loading": _ctx.modalLoading,
    tabs: _ctx.tabsList,
    onHide: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('hide')))
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_AppInputsValidationProvider, {
              "shake-tre": _ctx.parentTouched,
              onChangeErrorState: _ctx.onChangeErrorState
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_AppInput, {
                      id: "package-title",
                      modelValue: _ctx.packageModel.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.packageModel.title) = $event)),
                      label: "Title",
                      "input-type": "material",
                      "validation-type": "notEmptyString",
                      required: true
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_SelectInput, {
                      options: _ctx.mappedProvider,
                      label: "Provider",
                      onSelect: _ctx.selectProvider
                    }, null, 8, ["options", "onSelect"])
                  ])
                ]),
                (_ctx.selectedProvider !== 'EsimGo')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_SelectInput, {
                          options: _ctx.eSimTypes,
                          label: "eSIM type",
                          onSelect: _ctx.selectEsimType
                        }, null, 8, ["options", "onSelect"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_SelectInput, {
                      options: _ctx.packageModel.currentPlans,
                      label: "Plan",
                      onSelect: _ctx.selectPlan
                    }, null, 8, ["options", "onSelect"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_SelectDataTypes, {
                      "selected-data-type-id": _ctx.selectedDataTypeId,
                      onSelect: _ctx.selectDataType
                    }, null, 8, ["selected-data-type-id", "onSelect"])
                  ])
                ]),
                (_ctx.showField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_SelectBundle, {
                          key: "select-bundle",
                          "selected-bundle-id": _ctx.selectedBundleId,
                          "filter-by-zone": _ctx.currentZoneName,
                          provider: _ctx.selectedProvider,
                          onSelect: _ctx.selectBundle
                        }, null, 8, ["selected-bundle-id", "filter-by-zone", "provider", "onSelect"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_SelectInput, {
                          key: "select-traffic-amount",
                          options: _ctx.mappedTraffic,
                          label: "Traffic amount",
                          "list-max-width": "200px",
                          onSelect: _ctx.selectTraffic
                        }, null, 8, ["options", "onSelect"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_SelectPurchaseType, {
                          "selected-purchase-type-id": _ctx.selectedPurchaseTypeId,
                          onSelect: _ctx.selectPurchaseType
                        }, null, 8, ["selected-purchase-type-id", "onSelect"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_SelectValidityType, {
                          "selected-validity-type-id": _ctx.selectedValidityTypeId,
                          onSelect: _ctx.selectValidityType
                        }, null, 8, ["selected-validity-type-id", "onSelect"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showField)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(
                  _ctx.selectedLocationType === 'countries' ? 'col-6' : 'col-12'
                )
                      }, [
                        _createVNode(_component_AppInput, {
                          id: "default-price",
                          modelValue: _ctx.localDefaultPrice,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDefaultPrice) = $event)),
                          style: _normalizeStyle(
                    _ctx.selectedLocationType === 'countries'
                      ? 'color: #828282;'
                      : ''
                  ),
                          class: _normalizeClass(
                    _ctx.selectedLocationType === 'countries' ? 'disabled' : ''
                  ),
                          "input-type": "material",
                          readonly: _ctx.selectedLocationType === 'countries',
                          "validation-type": "notEmptyString",
                          label: _ctx.getLabelForInput
                        }, null, 8, ["modelValue", "style", "class", "readonly", "label"])
                      ], 2),
                      (_ctx.selectedLocationType === 'countries')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(_component_AppInput, {
                              id: "default-commission",
                              modelValue: _ctx.packageCommission,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.packageCommission) = $event)),
                              "input-type": "material",
                              type: "number",
                              "validation-type": "notEmptyString",
                              label: "Commission in %"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_AppButton, {
                      type: "secondary",
                      size: "xl",
                      disabled: _ctx.submitError,
                      loading: _ctx.loading,
                      onClick: _ctx.submitHandler
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isEdit ? "Edit" : "Add") + " package ", 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading", "onClick"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["shake-tre", "onChangeErrorState"])
          ])
        ], 32)
      ])),
      (_openBlock(), _createElementBlock("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("strong", _hoisted_24, [
            (_ctx.updatedOperators.length)
              ? (_openBlock(), _createElementBlock("b", _hoisted_25, " Coverage & Carrier Network for " + _toDisplayString(_ctx.selectedLocationName), 1))
              : (_openBlock(), _createElementBlock("b", _hoisted_26, " Coverage & Carrier Network for " + _toDisplayString(_ctx.selectedLocationName) + " not found ", 1))
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              (_ctx.updatedOperators.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
                : _createCommentVNode("", true),
              (_ctx.updatedOperators.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("ul", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updatedOperators, ({ operator, networkGenerationString }, idx) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: operator.id,
                          class: "coverage-list--item"
                        }, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_Partner, {
                                title: operator.name,
                                image: operator.image
                              }, null, 8, ["title", "image"])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("strong", _hoisted_38, _toDisplayString(networkGenerationString), 1)
                            ])
                          ]),
                          (idx !== _ctx.updatedOperators.length - 1)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_39))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title", "opened", "modal-loading", "tabs"]))
}